<template>
  <LegalDocView
    type="terms"
    :title="$t('terms.title') || 'Allgemeine Geschäftsbedingungen'"
    :empty-text="$t('terms.empty', 'Die AGB wurden noch nicht veröffentlicht.')"
  />
</template>

<script setup>
import LegalDocView from '~/components/Legal/LegalDocView.vue'

definePageMeta({
  title: 'Terms and Conditions'
})
</script>
